import { render, staticRenderFns } from "./TheMenuRawItem.vue?vue&type=template&id=55b75b68&"
import script from "./TheMenuRawItem.vue?vue&type=script&lang=js&"
export * from "./TheMenuRawItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/lucia/proyectos/byl_salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55b75b68')) {
      api.createRecord('55b75b68', component.options)
    } else {
      api.reload('55b75b68', component.options)
    }
    module.hot.accept("./TheMenuRawItem.vue?vue&type=template&id=55b75b68&", function () {
      api.rerender('55b75b68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheMenuRawItem.vue"
export default component.exports